import { createV3Queries } from "@query/utils/createV3Queries";
import { vaultFilesApi } from "@api";

/**
 * Vault-file registry — mirrors `VaultFilesApi` 1:1
 * (`/v3/compliance/vault-files`).
 *
 * Uploading a local file is a three-step flow and therefore NOT a registry
 * entry: presign (`createVaultFileUpload`) → PUT the bytes at the returned
 * `uploadUrl` with its `requiredHeaders` → register (`createVaultFile` with
 * `uploadId`). Compose it at the consuming component's root — see
 * `Requirements/modules/SharedFile/components/useUploadFileModal.tsx`.
 *
 * `getVaultFileContent` is generated as `void` (the endpoint answers a redirect
 * and the spec declares no response body); read the bytes off
 * `getVaultFileContentRaw(...).raw`.
 */
export const queriesVaultFiles = createV3Queries(
  "vaultFilesApi",
  vaultFilesApi
);
